import $ from "jquery";
import { getPokemon } from "./main";

obtenerPokemon();

$("#inputPokemon").on("keydowm", (e) => {
  if (e.keyCode == 13) {
    e.preventDefault();
    return false;
  }
});

$("#buscar_pokemon").on("click", () => {
  let nombre = $("#inputPokemon").val();

  let pokemon = getPokemon(nombre);
  pokemon
    .then((res) => res.json())
    .then((res2) => {
      console.log(res2);
      let { name, sprites, stats, types } = res2;
      llenarInformacion(name, sprites, stats, types);
    })
    .catch((e) => {
      alert("El pokemon no fue encontrado!");
      window.location.reload;
    });
});

function obtenerPokemon() {
  let random = numeroAleatorio(150) + 1;
  let pokemon = getPokemon(random);
  pokemon
    .then((res) => res.json())
    .then((res2) => {
      console.log(res2);
      let { name, sprites, stats, types } = res2;
      llenarInformacion(name, sprites, stats, types);
    });
}

function numeroAleatorio(max) {
  return Math.floor(Math.random() * max);
}

function llenarInformacion(name, sprites, stats, types) {
  let input = document.getElementById("inputPokemon");
  input.placeholder = `Ingrese pokemon`;
  let div = $(".datos_pokemon");
  div.empty();

  let tabla = `<table class="table"> <tr><td class="font-weight-bold text-uppercase"> ${name} </td></tr>`;

  for (let i = 0; i < stats.length; i++) {
    tabla += "<tr>";
    tabla += `<td>${stats[i].stat.name}</td>`;
    tabla += `<td>${stats[i].base_stat}</td> `;
    tabla += "</tr>";
  }
  tabla += "</table>";
  div.append(tabla);

  let tabla2 = `<table class="table"> <tr><td class="font-weight-bold text-uppercase"> TYPES </td>`;

  for (let i = 0; i < types.length; i++) {
    tabla2 += `<td> ${types[i].type.name}</td>`;
  }
  tabla2 += `</tr></table>`;
  div.append(tabla2);

  let img = document.getElementById("pokemon_img");
  img.src = sprites.other.dream_world.front_default;
}
